import React, { useEffect, useState } from "react";
import { NGROK } from "../../../APIs";
import axios from "axios";
import { myLocalStorage } from "../../../components/StorageHelper";
import useUserStore from "../../../services/userStore";

import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Typography,
  Tab,
  Stack,
} from "@mui/material";

import { awsIcons } from "../AWS/AWSIcons";
import { CustomTabPanel } from "../../../GenericMethods";
import { TabContext, TabList } from "@mui/lab";
import { SiKubernetes } from "react-icons/si";
import { Shield as ShieldIcon } from "@mui/icons-material";
import K8Roles from "../Azure/Components/K8Roles";
import GCPGenericRoles from "./Components/GCPGenericRoles";
import TailwindFilterHeader from "../../../tailwind-ui/components/TailwindFilterHeader";
import useCloudSyncStore from "../../../services/useCloudSyncStore";
import { triggerCloudSync } from "../../../triggerCloudSync";
import useNotificationStore from "../../../services/notificationStore";

const GcpRoles = () => {
  const [tabValue, setTabValue] = useState("Roles");

  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;
  const [selectedTenantName, setSelectedTenantName] = useState(null);
  const [tenantList, setTenantList] = useState([]);
  const [isSyncing, setIsSyncing] = useState(false);
  const [projectIdList, setProjectIdList] = useState([]);

  const [projectId, setProjectId] = useState(null);

  const syncStatus = useCloudSyncStore((state) => state.syncStatus);

  const userData = useUserStore((state) => state.user);
  let { gcpConfig } = useNotificationStore.getState();

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const ondemandButton = async () => {
    try {
      const data = await triggerCloudSync(
        "gcp",
        "/api/gcp-sync/manual",
        selectedTenantName,
      );
      console.log("GCP Sync complete:", data);
    } catch (error) {
      console.error("GCP Sync failed", error);
    }
  };
  const handleTenantChange = (value) => {
    const tenant = tenantList.find((tenant) => tenant.tenantName === value);
    if (tenant !== undefined) {
      setSelectedTenantName(tenant.tenantName);
      myLocalStorage.setItem("latestTenant", tenant);
    }
  };
  const handleProject = (value) => {
    const project = projectIdList.find((project) => project === value);
    if (project !== undefined) {
      setProjectId(project);
      myLocalStorage.setItem("gcpSelectedProjectId", project);
    }
  };

  const fetchProjectIdList = async () => {
    const response = await axios.get(
      `${NGROK}/api/gcp/auth/fetchAllProjectIds`,
      {
        params: {
          tenantName: latestTenant,
        },
      },
    );
    setProjectIdList(response.data);
  };

  useEffect(() => {
    if (projectIdList.length === 1) return setProjectId(projectIdList[0]);

    if (projectIdList?.length > 1) {
      const latestprojectId = myLocalStorage.getItem("gcpSelectedProjectId");

      const project = projectIdList.find(
        (project) => project === latestprojectId,
      );
      if (project) setProjectId(project);
      else setProjectId(projectIdList[0]);
    }
  }, [projectIdList]);

  useEffect(() => {
    if (tenantList.length === 1)
      return setSelectedTenantName(tenantList[0].tenantName);

    if (tenantList?.length > 1) {
      const latestTenantName =
        myLocalStorage.getItem("latestTenant")?.tenantName;

      const tenant = tenantList.find(
        (tenant) => tenant.tenantName === latestTenantName,
      );
      if (tenant) setSelectedTenantName(tenant.tenantName);
      else setSelectedTenantName(tenantList[0].tenantName);
    }
  }, [tenantList]);

  useEffect(() => {
    const fetchTenants = async () => {
      const response = await axios.get(`${NGROK}/api/get-all-domains`);
      setTenantList(response.data);
    };
    fetchTenants();
  }, [userData]);

  useEffect(() => {
    fetchProjectIdList();
  }, [latestTenant]);

  return (
    <>
      <TailwindFilterHeader
        title="GCP Roles"
        isIconNeeded={true}
        subtitle={"Manage cloud roles and permissions"}
        dropdowns={[
          {
            label: "Tenant",
            value: selectedTenantName,
            options: tenantList.map((t) => ({
              label: t.tenantName,
              value: t.tenantName,
            })),
            onChange: handleTenantChange,
          },
          {
            label: "Project",
            value: projectId,
            options: projectIdList.map((p) => ({
              label: p,
              value: p,
            })),
            onChange: handleProject,
          },
        ]}
        tabs={[
          { label: "Roles", value: "Roles", icon: ShieldIcon },
          { label: "Kubernetes", value: "K8", icon: SiKubernetes },
        ]}
        activeTab={tabValue}
        onTabChange={setTabValue}
        isSyncing={syncStatus["gcp"]}
        onSync={ondemandButton}
        isSyncNeeded={gcpConfig ? true : false}
      />

      <CustomTabPanel value={tabValue} index="Roles">
        <GCPGenericRoles latestTenant={latestTenant} projectId={projectId} />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index="K8">
        <K8Roles
          selectedTenantName={selectedTenantName}
          allapi={`/api/gcp/kubernetes-clusters?tenantName=${selectedTenantName}&projectId=${projectId}`}
          rolesApi="/api/k8-resources/v1/roles/byClusterId"
          rolespoliciesApi="/api/k8-resources/v1/rolePolicies/byRoleUid"
          cloud="GCP"
        />
      </CustomTabPanel>
    </>
  );
};

export default GcpRoles;
